var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ElementRef, ChangeDetectorRef, Renderer2, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { EngineService } from 'src/app/engine/engine.service';
import { AnimationService } from 'src/app/engine/animation.service';
import { ViewService } from '../../view.service';
import { filter, takeUntil, throttleTime, auditTime } from 'rxjs/operators';
import { EventsEnum } from 'src/app/engine/models/events.enum';
import { ViewState } from '../../state/view.state';
export class ViewScrubberComponent {
    // ---------- Lifecycle Hooks ----------
    constructor(engineService, animationService, renderer, viewService, changeDetectorRef, store) {
        this.engineService = engineService;
        this.animationService = animationService;
        this.renderer = renderer;
        this.viewService = viewService;
        this.changeDetectorRef = changeDetectorRef;
        this.store = store;
        // ---------- Inputs ----------
        this.showHandle = true;
        // ---------- Class Variables ----------
        this.ngUnsubscribe = new Subject();
        this.trackWidth = 0;
        this.dragPosition = { x: 16, y: 0 };
        this.dragMove = new Subject();
    }
    ngOnInit() {
        this.initChapterListener();
        this.initTimelineListener();
        this.initDragListener();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    // ---------- Listeners ----------
    initChapterListener() {
        this.selectedChapterId$.pipe(filter(chapterId => chapterId != null), takeUntil(this.ngUnsubscribe)).subscribe((chapterId) => {
            this.timerange = this.animationService.getChapterLocalTimerange(chapterId);
        });
    }
    initTimelineListener() {
        // Listen to timeline ticks
        this.engineService.getEvent(EventsEnum.TimelinePlaying)
            .pipe(throttleTime(20), takeUntil(this.ngUnsubscribe))
            .subscribe(event => this.tick(event.time));
        // listen for timeline scrub
        this.engineService.getEvent(EventsEnum.TimelineScrubbed)
            .pipe(throttleTime(20), takeUntil(this.ngUnsubscribe))
            .subscribe((event) => {
            // manually set scrubber UI
            const scrubPercent = this.calcScrubbedPercent(event.time);
            this.setScrubberBar(scrubPercent);
        });
    }
    initDragListener() {
        this.dragMove.pipe(auditTime(20), takeUntil(this.ngUnsubscribe)).subscribe((event) => {
            const percent = this.calculateHandlePercent();
            this.scrubToPercent(percent);
        });
    }
    // ---------- Class Methods ----------
    handleDragMoved(event) {
        this.dragMove.next(event);
    }
    tick(time) {
        if (!this.timerange) {
            return;
        }
        const scrubPercent = this.calcScrubbedPercent(time);
        this.setScrubberBar(scrubPercent);
        if (this.trackWidth === 0) {
            this.trackWidth = this.track.nativeElement.offsetWidth;
        }
        if (this.showHandle) {
            this.dragPosition = Object.assign({}, this.dragPosition, { x: 16 + this.trackWidth * (scrubPercent / 100) });
            this.changeDetectorRef.markForCheck();
        }
    }
    calculateHandlePercent() {
        const { left, right } = this.scrubber.nativeElement.getBoundingClientRect();
        const adjustedWidth = right - left - 32; // Account for padding
        const handleLeft = this.handle.nativeElement.getBoundingClientRect().left;
        const percent = (handleLeft - left) / adjustedWidth * 100;
        return percent;
    }
    scrubToPercent(percent) {
        const localTime = (percent / 100) * this.timerange.lastTime;
        const which = (percent === 0) ? 'second' : 'first';
        const activeChapterId = this.store.selectSnapshot(StoryChaptersState.getSelectedChapterId);
        const globalTime = this.animationService.mapLocalTimeToGlobal(activeChapterId, localTime);
        this.animationService.scrub({ time: globalTime, which });
    }
    handlePlayClick() {
        this.viewService.toggleAnimation();
    }
    setScrubberBar(percent) {
        this.renderer.setStyle(this.bar.nativeElement, 'width', `${percent}%`);
    }
    calcScrubbedPercent(time) {
        const { firstTime, lastTime } = this.timerange;
        const localTime = this.animationService.mapGlobalTimeToLocal(time).time;
        // keep time in range
        const normalizedTime = Math.max(firstTime, Math.min(localTime, lastTime));
        const scrubPercent = Math.round((normalizedTime / lastTime) * 100);
        return scrubPercent;
    }
}
__decorate([
    Select(EngineState.getAnimationPlaying),
    __metadata("design:type", Observable)
], ViewScrubberComponent.prototype, "animationPlaying$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapterId),
    __metadata("design:type", Observable)
], ViewScrubberComponent.prototype, "selectedChapterId$", void 0);
__decorate([
    Select(ViewState.getCanTouch),
    __metadata("design:type", Observable)
], ViewScrubberComponent.prototype, "canTouch$", void 0);
